import React from 'react';
import { useWindowSize } from 'react-use';
import { copyFor } from 'config';
import { screenIsSmall } from 'utils/screen-is-small';
import SolarPanels from '/images/solar/single-solar-panel.svg';
import { Grid, LeftColumnGridCell, RightColumnGridCell } from 'styles';
import { PageHeading } from 'components/page-heading';
import { Welcome } from 'pages/solar/components/welcome';
import { EnrollmentTimelineAvailable } from 'components/enrollment-timeline';
import { ProjectDetails } from 'pages/solar/components/project-details';
import { FinishSetupCta } from 'pages/solar/components/finish-setup-cta';
import { EnergyBreakdown } from 'pages/solar/components/energy-breakdown';
import { StateSolarFarms } from 'pages/solar/components/state-solar-farms';
import { AdvocacyModule } from 'pages/solar/components/advocacy-module';
import { SolarNotification } from 'pages/solar/components/solar-notification';
import { ReconnectUtilityNotification } from 'pages/solar/components/reconnect-utility-notification';

const getProjectDetailsCopy = copyFor('solar.projectDetails.available');

export const Available = ({
  advocacyCampaign,
  completedAdvocacyCampaign,
  hasAdvocacyCampaignSubmission,
  pageHeading,
  stateAbbreviation,
  stateFullName,
  stateId,
  vnmSolarProjectsStatistics,
  zipCode,
  utilityAccountId,
}: SolarActiveViewProps) => {
  const { width } = useWindowSize();
  const projectDetailProps = {
    location: getProjectDetailsCopy('location', {
      state: stateFullName,
    }),
    mdIdentifier: null,
    svgSrc: SolarPanels,
    title: getProjectDetailsCopy('title'),
  };

  return (
    <>
      <SolarNotification />
      <PageHeading page={pageHeading} />
      <ReconnectUtilityNotification />
      <Grid width="100%" gap="24px">
        <LeftColumnGridCell>
          {screenIsSmall(width) && <FinishSetupCta state={stateFullName} />}
          <Welcome state={stateFullName}>
            <EnrollmentTimelineAvailable />
          </Welcome>
          <AdvocacyModule
            advocacyCampaign={advocacyCampaign}
            completedAdvocacyCampaign={completedAdvocacyCampaign}
            hasAdvocacyCampaignSubmission={hasAdvocacyCampaignSubmission}
            margin={{ top: '24px' }}
            stateAbbreviation={stateAbbreviation}
            stateFullName={stateFullName}
            utilityAccountId={utilityAccountId}
          />
          <StateSolarFarms
            stateFullName={stateFullName}
            stateId={stateId}
            vnmSolarProjectsStatistics={vnmSolarProjectsStatistics}
          />
        </LeftColumnGridCell>
        <RightColumnGridCell>
          {!screenIsSmall(width) && <FinishSetupCta state={stateFullName} />}
          <ProjectDetails {...projectDetailProps} />
          <EnergyBreakdown zipCode={zipCode} />
        </RightColumnGridCell>
      </Grid>
    </>
  );
};
